import { baseUrl as apiBaseUrl } from '../../config/appsettings';

const baseUrl = apiBaseUrl + 'AdsTxt';

const AdTxtApiService = {

  getAdFile: async (filetype) => {
    try {
      const response = await fetch(`${baseUrl}/GetAdFile?fileType=${filetype}`, {
        method: 'GET',
        //headers: { 'Content-Type': 'application/json' },
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Error fetching adunits');
      }
      const blob = await response.blob(); // Convert response to Blob
      return await blob.text(); // Convert Blob to text

    } catch (error) {
      console.error('Error:', error);
      throw new Error('Network error');
    }
  },
  DownloadAdFile: async (filetype) => {
    try {
      const url = `${baseUrl}/GetAdFile?fileType=${filetype}&isFromDownload=true`;
      window.location.href = url;
    } catch (error) {
      console.error('Error:', error);
      throw new Error('Network error');
    }
  },

  UpdateAdFile: async (fileData) => {
    try {
      const response = await fetch(`${baseUrl}/UpdateAdFiles`, {
        method: 'POST',
        body: fileData,
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Error updating file');
      }

      return await response.json();
    } catch (error) {
      console.error('Error:', error);
      throw new Error('Network error');
    }
  }
};

export default AdTxtApiService;
